import { apiRequest } from "../../services/apiService";
import {
  ADD_CUSTOM_VARIABLE_VALUE_FAIL,
  ADD_CUSTOM_VARIABLE_VALUE_REQUEST,
  ADD_CUSTOM_VARIABLE_VALUE_SUCCESS,
  DELETE_CUSTOM_VARIABLE_VALUE_FAIL,
  DELETE_CUSTOM_VARIABLE_VALUE_REQUEST,
  DELETE_CUSTOM_VARIABLE_VALUE_SUCCESS,
  GET_CUSTOM_VARIABLE_VALUE_LIST_FAIL,
  GET_CUSTOM_VARIABLE_VALUE_LIST_REQUEST,
  GET_CUSTOM_VARIABLE_VALUE_LIST_SUCCESS,
  UPDATE_CUSTOM_VARIABLE_VALUE_FAIL,
  UPDATE_CUSTOM_VARIABLE_VALUE_REQUEST,
  UPDATE_CUSTOM_VARIABLE_VALUE_SUCCESS,
} from "../constant";

export const getCustomVariableValueList = (data) => {
  return async (dispatch) => {
    dispatch({ type: GET_CUSTOM_VARIABLE_VALUE_LIST_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/custom-variable-value/question-variable-list`,
      data: data
    });
    if (response) {

      dispatch({
        type: GET_CUSTOM_VARIABLE_VALUE_LIST_SUCCESS,
        payload: response?.data?.data,
      });
    } else if (error) {
      dispatch({ type: GET_CUSTOM_VARIABLE_VALUE_LIST_FAIL });
    }
  };
};

export const addCustomVariableValue = (data, successCallBack) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CUSTOM_VARIABLE_VALUE_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/custom-variable-value/add-custom-variable-value`,
      data: data
    });
    if (response) {
      dispatch({
        type: ADD_CUSTOM_VARIABLE_VALUE_SUCCESS,
        payload: response?.data?.data,
      });
      successCallBack();
    } else if (error) {
      dispatch({ type: ADD_CUSTOM_VARIABLE_VALUE_FAIL });
    }
  };
};

export const editCustomVariableValue = (data, successCallBack) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CUSTOM_VARIABLE_VALUE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `/custom-variable-value/update-custom-variable-value`,
      data: data
    });
    if (response) {
      dispatch({
        type: UPDATE_CUSTOM_VARIABLE_VALUE_SUCCESS,
        payload: response?.data?.data,
      });
      successCallBack()
    } else if (error) {
      dispatch({ type: UPDATE_CUSTOM_VARIABLE_VALUE_FAIL });
    }
  };
};

export const deleteCustomVariableValue = (data, successCallBack) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CUSTOM_VARIABLE_VALUE_REQUEST });
    const { response, error } = await apiRequest({
      method: "DELETE",
      url: `/custom-variable-value/delete-custom-variable-value`,
      data: data
    });
    if (response) {
      dispatch({
        type: DELETE_CUSTOM_VARIABLE_VALUE_SUCCESS,
        payload: response?.data?.data,
      });
      successCallBack()
    } else if (error) {
      dispatch({ type: DELETE_CUSTOM_VARIABLE_VALUE_FAIL });
    }
  };
};
